<template>
  <div class="confirm-stage" :class="{'active': formSectionComplete}">
    <div class="d-title">
      <span class="lbl-cap8 text-bold">{{number}}. Services Selected</span>
      <div class="action-edit" @click="gotoEdit(1)" v-if="formSectionComplete">Edit</div>
    </div>
    <div class="d-detail" v-if="formSectionComplete">
      <div class="lbl-cap6 text-cap">
        <span v-for="service in formStore" :key="service.id">{{service.category}} - {{service.name}}, </span>
      </div>
      <div class="off-site-btn-area" v-if="user.off_site">
        <div class="off-site-btn">Off-Site Visit</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    number: Number
  },
  computed: {
    section(){
      return this.$store.state.components.appointment.steps[1];
    },
    user(){
      return this.$store.state.user;
    },
    formStore(){
      return this.$store.state.user.services;
    },
    formSectionComplete(){
      return this.$store.getters.formServices;
    }
  },
  methods: {
    gotoEdit:function(index){
      this.$emit('goToEdit',index);
    }
  }
}
</script>